import { apiFetcher } from "./apiFetcher";
import qs from "qs";
import _ from 'lodash'

export const categoriesService = {
  getAllCategories
};

function getAllCategories(storeId, page, categoriesArray, accessToken, options = { filters: {} }) {
  const url = `category?${qs.stringify(options.filters)}`

  return apiFetcher(storeId, accessToken, url, { method: "GET" });
}